import { render, staticRenderFns } from "./CompanyOrganization.vue?vue&type=template&id=f584318c"
import script from "./CompanyOrganization.vue?vue&type=script&lang=js"
export * from "./CompanyOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports